import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '@app/services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit{
  logo: any;

  public ngOnInit(): void {
    this.logo = LocalStorageService.getLogo();
  }
}
